const createCase = async (normalizedValues, options) => {
  const { createParcelClaim, errorMessage, onSuccess, overlay, onError } = options;
  try {
    overlay == null ? void 0 : overlay.show();
    const result = await createParcelClaim(normalizedValues);
    const caseId = result.id;
    onSuccess == null ? void 0 : onSuccess(caseId);
    return caseId;
  } catch (error) {
    onError == null ? void 0 : onError({ message: errorMessage });
    throw error;
  } finally {
    overlay == null ? void 0 : overlay.hide();
  }
};
export {
  createCase as default
};
//# sourceMappingURL=createCase.js.map
